/**
 * Read a cookie value by name.
 * @param {string} name - Name of the cookie to read.
 * @returns {string|null} - Decoded cookie value, or null if not present.
 */
export function getRawCookie (name) {
  try {
    // escape any RegExp metacharacters in the name
    const safeName = name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1')
    const regex = new RegExp('(?:^|; )' + safeName + '=([^;]*)')
    const match = document.cookie.match(regex)
    return match ? decodeURIComponent(match[1]) : null
  } catch {
    return null
  }
}
